export default __webpack_public_path__ + "static/media/hero-video-16x9-es.5e0ae5e9.mp4";